import BaseApi from './base'

class Notification extends BaseApi {
  constructor() {
    super()
    this.client.defaults.baseURL = `${this.notificationURL}/admin/`
  }

  getNotificationInApps = (email, query) =>
    this.client.get(`notification-in-app/${email}?${query}`)

  getNotificationPushById = (id, data) =>
    this.client.get(`notification-push/${id}?${data}`)
}

export default new Notification()
